import { treeSentryBox } from "@/api/module/tenant";
import { getTenantId, getIsSentryBoxTabs, getRoleCode } from "@/utils/service";

import {
  orderPubSub,
} from "../service/pubsub/index";

export default {
  props: {
    treeSentryId: {
      type: [String, Number],
      default: undefined,
    },
  },
  data() {
    return {
      height: 0,
      mainHeight: 0,
      path: "",
      ws: null,
      data: [],
      time: null,
      sentryId: undefined,
      timeTreeSentryBox: null,
      wsUrl: undefined,
      camStatusData: [],
      ShowPassIn: {}
    }
  },
  computed: {
    tenantId: function () {
      return this.$store.state.user.tenantId > 0 ? this.$store.state.user.tenantId : parseInt(getTenantId()) ;
    },
    isMenuCollapse: function () {
      return this.$store.state.layout.isMenuCollapse;
    },
    isInitWs: function () {
      return this.$store.state.layout.isInitWs;
    },
    wsOrderArr: function () {
      let arr = this.$store.state.order.moreWsData.lastKey ? this.$store.state.order.moreWsData : JSON.parse(sessionStorage.getItem('moreWsData'));
      return arr[arr.lastKey];
    },
    gateId: function () {
      return this.$store.state.order.payOrderGateId;
    },
    gateIds: function() {
      return this.$store.state.order.gateIds
    },
    gateIdsSortStr: function () {
      return this.$store.state.order.gateIdsSortStr;
    },
    videoGateIds: function() {
      return this.$store.state.order.videoGateIds
    },
    isSentryBoxManager : function () {
      return this.$store.state.layout.isSentryBoxTabs ? this.$store.state.layout.isSentryBoxTabs === 'true' : getIsSentryBoxTabs() === 'true';
    },
    autoCompleteSelect: function () {
      return this.$store.state.order.autoCompleteSelect;
    },
    moreWsData: function() {
      return this.$store.state.order.moreWsData;
    },
    moreWsDataStr: function() {
      return this.$store.state.order.moreWsDataStr
    },
    moreBlackParkIn: function () {
      let obj = this.$store.state.order.moreBlackParkIn.lastKey ? this.$store.state.order.moreBlackParkIn : JSON.parse(sessionStorage.getItem('moreBlackParkIn'));
      return obj;
    },
    moreBlackParkInStr: function () {
      return this.$store.state.order.moreBlackParkInStr;
    },
    showPassInStr: function () {
      return this.$store.state.layout.showPassInStr;
    },
    showOrderDetail: function () {
      return this.$store.state.order.showOrderDetail
    },
    showLeftSide: function () {
      return this.$store.state.layout.showLeftSide;
    },
  },
  watch: {
    videoGateIds: 'setCamStatusFun',
    camStatusData: 'setCamStatusFun',
  },
  mounted() {
    this.server();
  },
  methods:{
    getBaseUrl() {
      let basic = location.href.split('#')[0].length > location.href.split('?')[0].length ?  location.href.split('?')[0] : location.href.split('#')[0];
      basic = basic.replace('http', 'ws');
      return  process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'build_test' ? basic + 'api/client/wsService' : process.env.VUE_APP_WS;
    },
    connectWsData(Data) {
      return new Promise(resolve => {
        if (Data.message_type === "1" && Data.direction === "1") {
          let obj = JSON.parse(Data.otherMsg);
          // console.log(obj.passInFullImage)
          this.$store.dispatch("SetLiveImages", JSON.stringify({passInFullImageArr: [obj.passInFullImage], passOutFullImageArr: [], outGateId: undefined, inGateId: parseInt(Data.park_lot_gate_id)}));
          resolve({key: 'parkIn'});
        } else if (Data.message_type === "2" && Data.direction === "2") {
          if (Data.pass_time) {
            let wsObj = {
              isWs: true,
              isPaid: false,
              Id: Data.order_id,
              order_id: Data.order_id,
              park_lot_gate_id: Data.park_lot_gate_id,
              message_type: Data.message_type,
              otherMsg: Data.otherMsg,
              plate_number: Data.plate_number,
              freeOrderShow: Data.FreeOrderShow,
              key: 'parkOut2',
            };
            resolve(wsObj);
          }
        } else if (Data.message_type === "6" && Data.direction === "2" && Data.FreeOrderShow !== '0') {
          // parkInPubSub.publish(Data);
          let wsObj = {
            isWs: true,
            isPaid: false,
            Id: Data.order_id,
            order_id: Data.order_id,
            park_lot_gate_id: Data.park_lot_gate_id,
            message_type: Data.message_type,
            plate_number: Data.plate_number,
            freeOrderShow: Data.FreeOrderShow,
            InfoMsg: '已放行',
            key: 'parkOut',
          };
          resolve(wsObj);
        } else if (Data.message_type === "5") {
          let wsObj = {
            isWs: true,
            isPaid: false,
            Id: Data.order_id,
            order_id: Data.order_id,
            park_lot_gate_id: Data.park_lot_gate_id,
            freeOrderShow: Data.FreeOrderShow,
            message_type: Data.message_type,
            plate_number: Data.plate_number,
            InfoMsg: '已放行',
            key: 'parkOut',
          };
          if (Data.direction === "2") {
            resolve(wsObj);
          } else if (Data.direction === "1") {
            resolve({key: 'blackParkIn'});
          }
        }else if (Data.message_type === "100") {
          resolve({key: 'realInOutList'});
        } else if (Data.message_type === '23') {
          resolve({key: 'userInfo'});
        } else if (Data.message_type === "20" || Data.message_type === "30" || Data.message_type === "32" || Data.message_type === "31") {
          resolve({key: 'blackParkIn'});
        } else if (Data.message_type === "camStatus") {
          resolve({key: 'camStatusData'});
        } else if (Data.message_type === "sendSpotNum") {
          // console.log('sendSpotNum', Data.SpotNum);
          resolve({key: 'spotNum'});
        } else if (Data.message_type === "deviceStatus" || Data.message_type === "billRule") {
          // console.log('sendSpotNum', Data.SpotNum);
          resolve({key: 'deviceStatus'});
        }
      })
    },
    // 处理数据
    handleData(data) {
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        let res = data[i];
        let Res = {
          Id: res.Id,
          Name: res.Name,
          isParkLot: true,
          children: [],
          BillPackCarNum: res.BillPackCarNum,
          SpotCount: res.SpotCount,
          SpotCanUseCount: res.SpotCanUseCount,
          CarNum: res.CarNum,
        };
        if (res.IsParkLot) {
          if (res.Node) {
            res.Node.forEach(v =>{
              v.treeIndex = `/home/tenant/${Res.Id}/${Res.Name}/${v.Id}/${v.Name}` + "";
            })
            Res.children = [...res.Node];
          }
          arr.push(Res);
        }
      }
      return arr;
    },
    getTreeSentryBox() {
      return new Promise(resolve => {
        treeSentryBox({
          level: 4,
          tenantId: this.tenantId,
          sentryId: this.sentryId,
        }).then(res => {
          if (getRoleCode() === 'sentryBox' && this.isSentryBoxManager) {
            let arr =  [];
            res.data.forEach(v => {
              arr = arr.concat(v.Node)
            });
            this.$store.dispatch("SetIsSentryBoxTabs", String(arr.length > 1));
          }
          resolve(res);
        });
      })
    },
    initJump(data, oldTenantId) {
      return new Promise(resolve => {
        let reg = /.*[\u4e00-\u9fa5]+.*$/;
        this.data = [];
        this.data = this.handleData(data);
        let { ParkLotId, GateId, GateName } = this.$route.params;
        if (ParkLotId &&
          GateId &&
          GateName &&
          (sessionStorage.getItem('loginSentryId') ? GateId === sessionStorage.getItem('loginSentryId') : GateId === sessionStorage.getItem('sentryId') || sessionStorage.getItem('loginSentryId') && sessionStorage.getItem('loginSentryId') === sessionStorage.getItem('sentryId')) &&
          this.$i18n.locale === 'zh' && reg.test(sessionStorage.getItem('sentryName'))
        ) {
          resolve({type: 1, url: this.$route.path})
        } else {
          if (sessionStorage.getItem('roleCode') === 'managerGate' && oldTenantId === 0) {
            resolve({type: 2, url: `/home/tenant/${sessionStorage.getItem('ParkLotId')}/${sessionStorage.getItem('ParkLotName')}/${sessionStorage.getItem('sentryId')}/${sessionStorage.getItem('sentryName')}`})
          } else {
            resolve({type: 2, url: `/home/tenant/${this.data[0].Id}/${this.data[0].Name}/${this.data[0].children[0].Id}/${this.data[0].children[0].Name}`})
          }
        }
      })
    },
    async refreshData() {
      if (this.time) {
        clearTimeout(this.time);
      }
      let res = await this.getTreeSentryBox();
      if (res.state === "success" && res.data.length > 0) {
        this.data.forEach(v => {
          let arr = res.data.filter(val => {return v.Id === val.Id});
          v.BillPackCarNum = arr[0].BillPackCarNum;
          v.SpotCount = arr[0].SpotCount;
          v.SpotCanUseCount = arr[0].SpotCanUseCount;
          v.CarNum = arr[0].CarNum;
          if (arr[0].Id === parseInt(this.$route.params.ParkLotId) && !this.isSentryBoxManager) {
            let ShowPassInArr = {};
            ShowPassInArr[this.$route.params.GateId] = arr[0].Node.filter(val => {return val.Id === parseInt(this.$route.params.GateId)})[0].ShowPassIn;
            ShowPassInArr[this.$route.params.GateId] = Boolean(ShowPassInArr[this.$route.params.GateId]);
            this.$store.dispatch("SetShowPassInStr", JSON.stringify(ShowPassInArr));
          }
        })
      }
      this.time = setTimeout(() => {
        this.refreshData();
      }, 30000);
    },
    pubOrder(wsObj) {
      // console.log(wsObj, this.wsOrderArr)
      if (!this.gateId) {
        this.$store.dispatch("SetPayOrderGateId", parseInt(wsObj.park_lot_gate_id));
        this.$store.dispatch("SetTabsGateId", wsObj.park_lot_gate_id);
      }
      if (this.gateId === parseInt(wsObj.park_lot_gate_id) || !this.showOrderDetail) this.$store.dispatch("GetShowOrderDetail", true);
      this.$nextTick(()=>{
        // console.log('orderPubSub', this.gateId, parseInt(wsObj.park_lot_gate_id));
        if (this.gateId === parseInt(wsObj.park_lot_gate_id)) {
          orderPubSub.publish(wsObj);
        } else {
          // console.log(this.gateId, this.moreWsData[this.moreWsData.lastKey]);
          let arr = this.moreWsData[this.moreWsData.lastKey].filter(v => {return parseInt(v.park_lot_gate_id) === this.gateId});
          if (arr.length > 0) {
            orderPubSub.publish(arr[0]);
          } else {
            orderPubSub.publish({Id: -1});
          }
        }
      })
    },
    storageRouter(data) {
      return new Promise(resolve => {
        let routerArr = data.split("/");
        let ParkLotId = routerArr[3];
        let ParkLotName =  routerArr[4];
        let sentryId = routerArr[5];
        let sentryName = routerArr[6];
        sessionStorage.setItem("ParkLotId", ParkLotId);
        sessionStorage.setItem("sentryId", sentryId);
        sessionStorage.setItem("sentryName", sentryName);
        sessionStorage.setItem("ParkLotName", ParkLotName);
        // this.refreshTreeSentryBox(ParkLotId, sentryId);
        this.$store.dispatch("SetParkLotId", Number(ParkLotId));
        this.$store.dispatch("GetShowOrderDetail", false);
        resolve({ParkLotId, sentryId});
      })
    },
    refreshTreeSentryBox(ParkLotId, sentryId) {
      return new Promise(resolve => {
        this.$store.dispatch("SetGateIds", []);
        this.getTreeSentryBox().then(res => {
          if (res.data.length > 0) {
            this.data = this.handleData(res.data);
            let GateId = [], GateIds = [];
            this.data.forEach((v) => {
              v.children.forEach((vv) => {
                if (vv.ParkLotId === Number(ParkLotId)) {
                  GateId = vv.Id;
                }
                if (vv.Id === Number(sentryId)) {
                  GateIds = vv.Node.map(v => {
                    v.online = undefined;
                    v.ip = undefined;
                    v.gateType = true;
                    return v;
                  });
                }
              });
            });
            if (
              Number(this.$store.state.order.parkLotId) === Number(ParkLotId) &&
              JSON.stringify(this.gateIds) ===
              JSON.stringify(GateId)
            ) {
              return false;
            }
            this.$store.dispatch("SetGateId", GateId);
            this.$store.dispatch("SetGateIds", GateIds);
            // console.log('refreshTreeSentryBox', GateIds)
            if (!this.isSentryBoxManager) this.$store.dispatch("SetVideoGateIds", GateIds);
            resolve(this.data.length > 0);
          }
        })
      })
    },
    async refreshVideo(sentryId) {
      let res = await this.getTreeSentryBox();
      if (res.data.length > 0) {
        let arr = this.handleData(res.data);
        let  GateIds = [];
        arr.forEach((v) => {
          v.children.forEach((vv) => {
            if (vv.Id === Number(sentryId)) {
              GateIds = vv.Node.map(v => {
                v.online = undefined;
                v.ip = undefined;
                v.gateType = true;
                return v;
              });
            }
          });
        });
        this.$store.dispatch("SetVideoGateIds", GateIds);
      }
    },
    setCamStatusFun() {
      // console.log(this.camStatusData)
      if (this.videoGateIds && this.camStatusData.length > 0) {
        this.videoGateIds.forEach(v => {
          let arr = this.camStatusData.filter(val => {
            return val.ParkLotGateId === v.Id
          });
          if (arr.length > 0) {
            this.$set(v, 'online', Boolean(arr[0].online));
            this.$set(v, 'ip', arr[0].ip);
          } else {
            this.$set(v, 'online', false);
            this.$set(v, 'ip', undefined);
          }
        });
        this.$store.dispatch("SETGateIdsStr", JSON.stringify(this.videoGateIds));
        // console.log('camStatus', this.videoGateIds)
      } else {
        this.$store.dispatch("SETGateIdsStr", JSON.stringify([]));
      }
    },
  }
};
